
import { defineComponent } from 'vue';
import LogoIcon from '@/components/LogoIcon.vue';

export default defineComponent({
  components: {
    LogoIcon,
  },
});
